export {
  MOCK_NOTIFICATIONS,
  NOTIFICATION_CATEGORIES,
  DEVICE_ID_KEY,
} from './notifications-data';
export type { Notification } from './notifications-data';
